import axios from 'axios';

const instance = axios.create({
    
    
    // baseURL:'https://localhost:44338/'
    baseURL:'/API/'
   
});

export default instance;